"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useSpectrumConditional = void 0;
var _react = require("react");
var _getSpectrumConditional = require("../color/getSpectrumConditional");
var _useSpectrum = require("../spectrum/useSpectrum");
/**
 * Conditionally return a value based on active spectrum.
 * @param config: An object with light and dark keys.
 * @returns value: The value to return when it's key is active.
 */
const useSpectrumConditional = ({
  light,
  dark
}) => {
  const spectrum = (0, _useSpectrum.useSpectrum)();
  return (0, _react.useMemo)(() => {
    return (0, _getSpectrumConditional.getSpectrumConditional)({
      light,
      dark
    }, spectrum);
  }, [spectrum, light, dark]);
};
exports.useSpectrumConditional = useSpectrumConditional;